import React, { createContext, useContext, useState } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
  const [items, setItems] = useState([{ title: "Дашбоард", href: "/" }]);

  return (
    <BreadcrumbContext.Provider value={{ items, setBreadcrumb: setItems }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
